/**
热卖商品
**/
<template>
  <div class="favoritGoods" v-if="favoritGoodsList.length>0?true:false">
    <div class="enjoy_title">
      <h3>猜你喜欢</h3>
    </div>
    <div class="no_enough">
      <ul>
        <li class="opacity_img1" v-for="item in favoritGoodsList" :key="item.id"  v-if="item.status == 1">
          <a href="javascript:;">
            <div class="p_img" style="overflow: hidden;">
              <!-- <img src="images/no_enough1.jpg" /> -->
              <router-link :to="stype==2?`/goodsdetail?id=${item.id}`:`/goodsDetail_supplie?id=${item.id}`">
                <el-image class="img-responsive selectItemCss_ls" :src="`${item.photos}`"
                  style="display: block"></el-image>
              </router-link>
            </div>
            <router-link :to="stype==2?`/goodsdetail?id=${item.id}`:`/goodsDetail_supplie?id=${item.id}`">
              <div class="no_ename" :title="item.name">
                {{item.name}}
              </div>
            </router-link>
            <div class="no_eprice"><em>¥</em>{{item.member_price||'--'}}</div>
            <!-- <div class="no_eprice"><em>¥</em>{{item.realprice!=-1?item.realprice:'面议'}}</div> -->
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { recommendFavorit, getPageIndex } from "@/api/xunyou";
  import "@/assets/css/style.css";
  export default {
    data () {
      return {
        favoritGoodsList: [],
      };
    },
    props: ['navTitle', 'articleList', 'stype'],
    // 注册组件
    components: {},
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created () {
      this.getCommoditylist()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 商品列表查询
      getCommoditylist () {
        this.loading = true;
        // recommendFavorit({
        //   muid: JSON.parse(localStorage.getItem("userdata")).userId || '',
        //   bXyCommodity:'', // 查全部
        //   stype:this.stype||''
        // })
        let parms = {
          id: 1,
          muid: JSON.parse(localStorage.getItem("userdata")) ? JSON.parse(localStorage.getItem("userdata")).userId : 0
        }
        getPageIndex(parms)
          .then((res) => {
            this.loading = false;
            // this.favoritGoodsList = res.rows.length>10? res.rows.slice(0,10):res.rows     
            // console.log(res.data,'res.data-----');
            
            if (res.data) {
              res.data.forEach(val => {
                if (val.ascription == 6) {
                  let goodslist = []
                  val.column.forEach((item) => {
                    if (item.cOrder == 1) {
                      goodslist.push(item.commodity);
                    }
                  })
                  this.favoritGoodsList = goodslist.length > 10 ? goodslist.slice(0, 10) : goodslist
                  console.log('this.favoritGoodsList', goodslist);
                }
              });

            }

          })
          .catch((err) => {
            this.loading = false;
            // this.$message.error("查询失败，请稍后再试！");
            console.log(err);

          });
      },
    },
  };
</script>

<style scoped lang='less'>
  .favoritGoods {
    margin: 40px 0;
  }

  .el-image.img-responsive.selectItemCss_ls {
    height: 100%;
    border-radius: 8px;
  }

  .nodate {
    text-align: center;
    margin-top: 20%;
    font-size: 16px;
  }

  .nodate .first {
    margin: 40upx 0 12upx;
    font-size: 28upx;
  }
</style>


// WEBPACK FOOTER //
// src/components/favoritGoods.vue